<template>
  <v-dialog v-model="dialog" max-width="500" :persistent="loading" >
    <v-card>
      <v-card-title>Mover para outro assento</v-card-title>
      <v-card-text>
        <v-card outlined class="pa-2 d-flex align-center gap-2 mb-2">
          <v-icon large>mdi-table-chair</v-icon>
          <div class="d-flex flex-column ml-2">
            <b class="mb-0">Assento atual</b>
            <span>{{ table?.name }}</span>
          </div>
        </v-card>

        <v-card outlined class="pa-2">
          <b class="mt-2 mb-1">Mesa de destino</b>
          <div v-if="innerLoading">
            <v-skeleton-loader type="image" class="rounded-b-0" />
            <v-skeleton-loader
              type="image"
              class="rounded-t-0"
              height="120px"
            />
          </div>
          <table-selector
            v-else-if="tableMap"
            :tableMap="tableMap"
            :party="party"
            :loading="innerLoading"
            colorMode="available"
            :statusGetter="(table) => table.status"
            v-model="newTable"
            containerId="change-table-selector"
          />
        </v-card>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="close" small text :disabled="loading"> Cancelar </v-btn>
        <v-spacer />
        <v-btn
          color="primary"
          @click="changeTable"
          :disabled="!newTable || loading"
          :loading="loading"
        >
          Mover
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import TABLE from "@/services/admin/party/table";
import TableSelector from "@/components/global/partyTable/TableSelector.vue";

export default {
  name: "ChangeTable",
  components: { TableSelector },
  props: {
    party: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    dialog: false,
    loading: false,
    error: null,
    table: null,
    tableMap: null,
    newTable: null,
    innerLoading: false,
  }),
  methods: {
    async getTableMap() {
      try {
        if (this.tableMap) return;
        this.innerLoading = true;
        const { tableMap } = await TABLE.get(
          this.party.organizationId,
          this.party.id
        );
        this.tableMap = tableMap || { backgroundUrl: null, Groups: [] };
      } catch (error) {
        console.error(error);
        this.error = error.message || "Erro ao carregar avaliações";
      } finally {
        this.innerLoading = false;
      }
    },
    open(table) {
      this.dialog = true;
      this.newTable = null;
      this.table = table;
      this.getTableMap();
    },
    close() {
      this.dialog = false;
      this.table = null;
    },
    async changeTable() {
      this.loading = true;
      try {
        await TABLE.transfer(
          this.party.organizationId,
          this.party.id,
          this.table.id,
          { tableId: this.newTable.id }
        );
        this.$emit("success");
        this.tableMap = null;
        this.close();
      } catch (error) {
        this.error = error.message || "Erro ao mover para outra mesa";
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.$root.$on("changeTable", this.open);
  },
  beforeDestroy() {
    this.$root.$off("changeTable", this.open);
  },
};
</script>
